module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "warning",
      "icon": "ti-cup",
      "title": "Suma szacowanych wpłat 1% łącznie",
      "value": _vm.statsValue['1_card'],
      "footerIcon": "ti-timer"
    }
  }), _vm._v(" "), _c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "success",
      "icon": "ti-wallet",
      "title": "Suma wpłat 1% z drukowanych deklaracji",
      "value": _vm.statsValue['2_card'],
      "footerIcon": "ti-timer"
    }
  }), _vm._v(" "), _c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "danger",
      "icon": "ti-info",
      "title": "Suma wpłat 1% z eDeklaracji",
      "value": _vm.statsValue['3_card'],
      "footerIcon": "ti-timer"
    }
  }), _vm._v(" "), _c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "info",
      "icon": "ti-email",
      "title": "Średnia kwota 1% (kwota / wypełnienie)",
      "value": _vm.statsValue['4_card'],
      "footerIcon": "ti-timer"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card cardText"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                    Wybierz zakres dla wykresów\n                    "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "Wybierz zakres daty",
      "range-separator": ",",
      "format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Suma wpłat 1%",
      "url": "api/legacy/upo",
      "time": "200000",
      "localName": "all",
      "dateRange": _vm.dateRange,
      "type": "sum",
      "amountValue": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Suma wpłat 1% z drukowanych deklaracji",
      "url": "api/legacy/upo",
      "time": "200000",
      "dateRange": _vm.dateRange,
      "localName": "send",
      "type": "sum",
      "type_from": "pc_send",
      "amountValue": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Suma wpłat 1% z eDeklaracji",
      "url": "api/legacy/upo",
      "time": "200000",
      "dateRange": _vm.dateRange,
      "localName": "upo",
      "type": "sum",
      "type_from": "pc_upo",
      "amountValue": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Średnia kwota 1% (kwota/wypełnienie) ",
      "url": "api/legacy/upo-ratio",
      "time": "200000",
      "dateRange": _vm.dateRange,
      "type": "sum",
      "localName": "ratio",
      "amountValue": true
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Podane w naszych statystykach "), _c('strong', [_vm._v("wpłaty 1% są kwotami szacunkowymi")]), _vm._v(",\n                    wynikającymi z zastosowania odpowiednich współczynników opartych\n                    na danych statystycznych z poprzednich lat, które\n                    generuje program PIT Format. Brane są pod uwagę kwoty 1% wskazane przez podatników w\n                    deklaracjach: "), _c('strong', [_vm._v("zapisanych jako pdf, wydrukowanych oraz wysłanych jako\n                        eDeklaracja")]), _vm._v(".\n\n                    Dane te mają charakter poglądowy, ponieważ nie jest możliwy pełny i dokładny\n                    monitoring wpłat 1%, np. nastąpiło wydrukowanie czy zapisanie pdf deklaracji w programie, ale\n                    nie dostarczono jej finalnie do urzędu skarbowego."), _c('br'), _vm._v("\n                    Wg naszych analiz wskazane kwoty mogą mieć odchylenie rzędu -/+ 10 %.\n\n\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b877f57e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Overview.vue
// module id = 451
// module chunks = 1